var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"a","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"},[React.createElement("stop",{"offset":"0","stopColor":"#56f5be","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#27c683","key":1})])),React.createElement("path",{"d":"M150.506,202.586h-151v-151a51.957,51.957,0,0,1,52-52h99a51.957,51.957,0,0,1,52,52v99a51.956,51.956,0,0,1-52,52Zm-68.858-155L67.505,61.728l40.081,40.081L67.505,141.89l14.143,14.142,54.223-54.223L81.648,47.586Z","transform":"translate(0.494 0.414)","fill":"url(#a)","key":1})]);
}

Logo.defaultProps = {"width":"202.999","height":"203","viewBox":"0 0 202.999 203"};

module.exports = Logo;

Logo.default = Logo;
